import {DrawRectangle} from '../service/tool/draw/element/shape/pointed/polygon/rectangle/DrawRectangle';
import {DrawLine} from '../service/tool/draw/element/shape/pointed/DrawLine';
import {DrawPolyline} from '../service/tool/draw/element/shape/pointed/polyline/DrawPolyline';
import {DrawEllipse} from '../service/tool/draw/element/shape/circular/DrawEllipse';
import {DrawPolygon} from '../service/tool/draw/element/shape/pointed/polygon/DrawPolygon';
import {FreeDrawer} from '../service/tool/draw/mode/FreeDrawer';
import {DrawIsoscelesTriangle} from '../service/tool/draw/element/shape/pointed/polygon/triangle/DrawIsoscelesTriangle';
import {DrawRightTriangle} from '../service/tool/draw/element/shape/pointed/polygon/triangle/DrawRightTriangle';
import {DrawTextBox} from '../service/tool/draw/element/foreign/DrawTextBox';
import {DrawCoordinatePlane} from '../service/tool/draw/element/complex/cartesian/DrawCoordinatePlane';
import {DrawVideo} from '../service/tool/draw/element/foreign/DrawVideo';
import {DrawImage} from '../service/tool/draw/element/foreign/DrawImage';
import {DrawForeignObject} from '../service/tool/draw/element/foreign/DrawForeignObject';
import {ElementType} from './constant/ElementType';
import {Drawer} from '../service/tool/draw/Drawer';
import {DrawCircle} from '../service/tool/draw/element/shape/circular/DrawCircle';
import {DrawTable} from '../service/tool/draw/element/complex/DrawTable';
import {DrawText} from '../service/tool/draw/element/foreign/DrawText';
import {DrawNumberLine} from '../service/tool/draw/element/complex/cartesian/DrawNumberLine';
import {DrawRay2} from '../service/tool/draw/element/complex/cartesian2/DrawRay2';
import {DrawGraphic} from '../service/tool/draw/element/complex/cartesian/DrawGraphic';
import {DrawTool} from '../service/tool/draw/DrawTool';
import {DrawCoordinatePlane2} from '../service/tool/draw/element/complex/cartesian2/DrawCoordinatePlane2';
import {DrawNumberLine2} from '../service/tool/draw/element/complex/cartesian2/DrawNumberLine2';
import {
  DrawParallelogram
} from '@app/modules/svg/service/tool/draw/element/shape/pointed/polygon/parallelogram/DrawParallelogram';
import {
  DrawIsoscelesTrapezoid
} from '@app/modules/svg/service/tool/draw/element/shape/pointed/polygon/trapezoid/DrawIsoscelesTrapezoid';
import {DrawCube} from '@app/modules/svg/service/tool/draw/element/shape/pointed/projected-3d/DrawCube';
import {DrawPyramid} from '@app/modules/svg/service/tool/draw/element/shape/pointed/projected-3d/DrawPyramid';
import {DrawPrism} from '@app/modules/svg/service/tool/draw/element/shape/pointed/projected-3d/DrawPrism';
import {DrawCylinder} from '@app/modules/svg/service/tool/draw/element/shape/pointed/projected-3d/DrawCylinder';
import {DrawCone} from '@app/modules/svg/service/tool/draw/element/shape/pointed/projected-3d/DrawCone';
import {DrawSphere} from '@app/modules/svg/service/tool/draw/element/shape/pointed/projected-3d/DrawSphere';
import {DrawParabola} from '@app/modules/svg/service/tool/draw/element/complex/cartesian/graphic/DrawParabola';
import {
  DrawAbsoluteValue
} from '@app/modules/svg/service/tool/draw/element/complex/cartesian/graphic/DrawAbsoluteValue';
import {DrawSquareRoot} from '@app/modules/svg/service/tool/draw/element/complex/cartesian/graphic/DrawSquareRoot';
import {DrawSin} from '@app/modules/svg/service/tool/draw/element/complex/cartesian/graphic/DrawSin';
import {DrawCos} from '@app/modules/svg/service/tool/draw/element/complex/cartesian/graphic/DrawCos';
import {DrawTan} from '@app/modules/svg/service/tool/draw/element/complex/cartesian/graphic/DrawTan';
import {DrawSegment} from "@app/modules/svg/service/tool/draw/element/complex/cartesian/graphic/DrawSegment";

export class Drawers {
  private readonly drawTool: DrawTool;
  public readonly free: FreeDrawer;
  public readonly line: DrawLine;
  public readonly polyline: DrawPolyline;
  public readonly ellipse: DrawEllipse;
  public readonly circle: DrawCircle;
  public readonly polygon: DrawPolygon;
  public readonly rectangle: DrawRectangle;
  public readonly parallelogram: DrawParallelogram;
  public readonly isoscelesTrapezoid: DrawIsoscelesTrapezoid;
  public readonly isoscelesTriangle: DrawIsoscelesTriangle;
  public readonly rightTriangle: DrawRightTriangle;
  public readonly textBox: DrawTextBox;
  public readonly text: DrawText;
  public readonly video: DrawVideo;
  public readonly image: DrawImage;
  public readonly foreignObject: DrawForeignObject;
  public readonly graphic: DrawGraphic;
  public readonly ray2: DrawRay2;
  public readonly segment: DrawSegment;
  public readonly coordinatePlane: DrawCoordinatePlane;
  public readonly numberLine: DrawNumberLine;
  public readonly coordinatePlane2: DrawCoordinatePlane2;
  public readonly numberLine2: DrawNumberLine2;
  public readonly parabola: DrawParabola;
  public readonly absoluteValue: DrawAbsoluteValue;
  public readonly squareRoot: DrawSquareRoot;
  public readonly sin: DrawSin;
  public readonly cos: DrawCos;
  public readonly tan: DrawTan;
  public readonly table: DrawTable;
  public readonly cube: DrawCube;
  public readonly pyramid: DrawPyramid;
  public readonly prism: DrawPrism;
  public readonly cylinder: DrawCylinder;
  public readonly cone: DrawCone;
  public readonly sphere: DrawSphere;

  public constructor(drawTool: DrawTool) {
    this.drawTool = drawTool;

    this.free = new FreeDrawer(drawTool);
    this.line = new DrawLine(drawTool);
    this.polyline = new DrawPolyline(drawTool);
    this.ellipse = new DrawEllipse(drawTool);
    this.circle = new DrawCircle(drawTool);
    this.polygon = new DrawPolygon(drawTool);
    this.rectangle = new DrawRectangle(drawTool);
    this.parallelogram = new DrawParallelogram(drawTool);
    this.isoscelesTrapezoid = new DrawIsoscelesTrapezoid(drawTool);
    this.isoscelesTriangle = new DrawIsoscelesTriangle(drawTool);
    this.rightTriangle = new DrawRightTriangle(drawTool);
    this.textBox = new DrawTextBox(drawTool);
    this.text = new DrawText(drawTool);
    this.video = new DrawVideo(drawTool);
    this.image = new DrawImage(drawTool);
    this.foreignObject = new DrawForeignObject(drawTool);
    this.graphic = new DrawGraphic(drawTool);
    this.ray2 = new DrawRay2(drawTool);
    this.segment = new DrawSegment(drawTool);
    this.coordinatePlane = new DrawCoordinatePlane(drawTool);
    this.numberLine = new DrawNumberLine(drawTool);
    this.coordinatePlane2 = new DrawCoordinatePlane2(drawTool);
    this.numberLine2 = new DrawNumberLine2(drawTool);
    this.parabola = new DrawParabola(drawTool);
    this.absoluteValue = new DrawAbsoluteValue(drawTool);
    this.squareRoot = new DrawSquareRoot(drawTool);
    this.sin = new DrawSin(drawTool);
    this.cos = new DrawCos(drawTool);
    this.tan = new DrawTan(drawTool);
    this.table = new DrawTable(drawTool);
    this.cube = new DrawCube(drawTool);
    this.pyramid = new DrawPyramid(drawTool);
    this.prism = new DrawPrism(drawTool);
    this.cylinder = new DrawCylinder(drawTool);
    this.cone = new DrawCone(drawTool);
    this.sphere = new DrawSphere(drawTool);
  }

  public getByType(type: ElementType): Drawer {
    switch (type) {
      case ElementType.ELLIPSE:
        return this.ellipse;
      case ElementType.CIRCLE:
        return this.circle;
      case ElementType.LINE:
        return this.line;
      case ElementType.FREE:
        return this.free;
      case ElementType.POLYLINE:
        return this.polyline;
      case ElementType.POLYGON:
        return this.polygon;
      case ElementType.RIGHT_TRIANGLE:
        return this.rightTriangle;
      case ElementType.ISOSCELES_TRIANGLE:
        return this.isoscelesTriangle;
      case ElementType.RECTANGLE:
        return this.rectangle;
      case ElementType.PARALLELOGRAM:
        return this.parallelogram;
      case ElementType.ISOSCELES_TRAPEZOID:
        return this.isoscelesTrapezoid;
      case ElementType.FOREIGN_OBJECT:
        return this.foreignObject;
      case ElementType.TEXT_BOX:
        return this.textBox;
      case ElementType.TEXT:
        return this.text;
      case ElementType.IMAGE:
        return this.image;
      case ElementType.VIDEO:
        return this.video;
      case ElementType.GRAPHIC:
        return this.graphic;
      case ElementType.RAY2:
        return this.ray2;
      case ElementType.SEGMENT:
        return this.segment;
      case ElementType.COORDINATE_PLANE:
        return this.coordinatePlane;
      case ElementType.NUMBER_LINE:
        return this.numberLine;
      case ElementType.COORDINATE_PLANE2:
        return this.coordinatePlane2;
      case ElementType.NUMBER_LINE2:
        return this.numberLine2;
      case ElementType.PARABOLA:
        return this.parabola;
      case ElementType.ABSOLUTE_VALUE:
        return this.absoluteValue;
      case ElementType.SQUARE_ROOT:
        return this.squareRoot;
      case ElementType.SIN:
        return this.sin;
      case ElementType.COS:
        return this.cos;
      case ElementType.TAN:
        return this.tan;
      case ElementType.TABLE:
        return this.table;
      case ElementType.CUBE:
        return this.cube;
      case ElementType.PYRAMID:
        return this.pyramid;
      case ElementType.PRISM:
        return this.prism;
      case ElementType.CYLINDER:
        return this.cylinder;
      case ElementType.CONE:
        return this.cone;
      case ElementType.SPHERE:
        return this.sphere;
      default:
        throw Error('Type is incorrect');
    }
  }
}
